import { createApp } from 'vue';
import ZipToTarBz2Converter from '@/Components/ZipToTarBz2Converter.vue';
import '@styles/app.css';

createApp(ZipToTarBz2Converter).mount('#zip-to-tar-bz2-converter');
